{
  "title": "Welcome",
  "logout": "Log out",
  "item_one": "1 item",
  "item_few": "{{count}} items",
  "item_other": "{{count}} items",
  "submit-registration-btn": "GO",
  "purchase-btn": "Purchase",
  "title-select-a-combo": "Choose a Combo",
  "title-select-a-la-carte": "A La Carte",
  "title-shopping-cart": "Shopping Cart",
  "title-change-image": "Select photo",
  "title-registered-selfies": "Registered Faces",
  "title-privacy": "Terms and Conditions",
  "title-faq": "FAQ",
  "select-image-done-btn-name_final": "Done",
  "select-image-done-btn-name_incomplete": "Next",
  "select-image-done-btn-counter_finite": "({{amount}}/{{total}})",
  "select-image-done-btn-counter_infinite": "({{amount}})",
  "remote-shoot-btn": "Shoot"
}